import { ReactElement } from 'react';
import { RMA_TYPE } from '@client/myAccount/rma/utils/rma';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useRouteLink, useRouterPush, useUrlCreator } from '@client/routes/hooks';
import { SearchResults } from './SearchResults';
import { Props } from './SearchResultsContainer.types';

export const SearchResultsContainer = (props: Props): ReactElement => {
  const push = useRouterPush();
  const { isStandalone, areResultsLimited, resultCount, results } = props;
  const urlCreator = useUrlCreator();
  const createRmaRoute = isStandalone
    ? ROUTES.createRma
    : ROUTES.myAccountCreateRma;
  const invoiceLink = useRouteLink(ROUTES.myAccountInvoice);
  const rmaItemLink = useRouteLink(ROUTES.product);

  const handleReturnClick = (invoiceId: string, sku: string, debitorId?: string): (() => void) => (): void => {
    push(
      urlCreator(createRmaRoute, {
        type: RMA_TYPE.return,
        invoiceId,
        sku,
        debitorId,
      }),
    );
  };

  const handleReturnAllClick = (invoiceId: string, debitorId?: string): (() => void) => (): void => {
    push(
      urlCreator(createRmaRoute, {
        type: RMA_TYPE.return,
        invoiceId,
        debitorId,
      }),
    );
  };

  const handleRepairClick = (
    invoiceId: string,
    sku: string,
    debitorId?: string,
  ): (() => void
) => () => {
    push(
      urlCreator(createRmaRoute, {
        type: RMA_TYPE.repair,
        invoiceId,
        sku,
        debitorId,
      }),
    );
  };

  return <SearchResults
    invoiceLink={invoiceLink}
    onRepairClick={handleRepairClick}
    onReturnAllClick={handleReturnAllClick}
    onReturnClick={handleReturnClick}
    rmaItemLink={rmaItemLink}
    areResultsLimited={areResultsLimited}
    isStandalone={isStandalone}
    resultCount={resultCount}
    results={results}
  />;
};

